
<div class="commentfield my-2 position-relative" >
  <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" ></ngx-editor-menu>
  <ngx-editor  #editorId [editor]="editor" placeholder="Write comment" [(ngModel)]="content" (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)"></ngx-editor>
  <a class="btn btn-outline-dark btn-sm noborder addfieldtoolbaricon position-absolute m-1" (click)="commandEnterHit()">
    ⌘
    <i class="bi bi-arrow-return-left"></i>
  </a>
</div>
<div class="mt-1">
  <div class="btn-group mx-2">
    @if (newComment == true) {
      <!--button type="button" class="btn btn-sm btn-outline-secondary noborder" (click)="addComment()" matTooltip="Save">
        <i class="bi bi-chat-square-dots"></i>
      </button-->
    }
    @if (newComment == false) {
      <!--button type="button" class="btn btn-sm btn-outline-secondary noborder" (click)="updateComment()" matTooltip="Save">
        <i class="bi bi-chat-square-dots"></i>
      </button-->
    }
    @if (newComment == false) {
      <button type="button" class="btn my-btn noborder" (click)="closeEditor()" matTooltip="Quit">
        <span class="mdi--window-close"></span>
      </button>
    }
    <app-uploadfile [organizationKey]="organizationKey" [projectKey]="projectKey" [contentKey]="commentKey" [userId]="userId" [contentType]="'comment'" [newContent]="newComment" [imageOnly]="false" (isFileUploaded)="isFileUploaded($event)" [projectName]="projectName" [captureImageImmediately]="false" (sendCoverImageUpdate)="updateCoverImage($event)"  [embbeddingModel]="embeddingModel" (orderGenerateDescription)="getImageDescription($event)" ></app-uploadfile>
  </div>
  @if (showAttachements == true) {
    <app-attachedfiles [organizationKey]="organizationKey" [contentKey]="commentKey" [smallSplash]="true"></app-attachedfiles>
  }
</div>
